// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2ZmMH","login__form":"style_login__form__2-I-8","input":"style_input__jh8re","person":"style_person__123ka","loading":"style_loading__3FG6K"};